import {useQuery} from '@tanstack/react-query';

import {selectCurrentProjectId} from '~redux/reducers/userReducer';
import {useAppSelector} from '~redux/index';

import {getInferenceMetaFields, getProjectData, getProjectMetadata} from './projects';

export const ProjectsQueryKeys = {
  all: ['projects'],
  currentProject: (projectId: string) => [...ProjectsQueryKeys.all, projectId] as const,
  projectMetadata: (projectId: string) => [...ProjectsQueryKeys.currentProject(projectId), 'metadata'] as const,
  inferenceMetaFields: (projectId: string) =>
    [...ProjectsQueryKeys.currentProject(projectId), 'inferenceMetaFields'] as const,
};

export function useCurrentProjectQuery(enabled: boolean = true) {
  const projectId = useAppSelector(selectCurrentProjectId);

  return useQuery({
    queryKey: ProjectsQueryKeys.currentProject(projectId),
    queryFn: () => getProjectData(projectId),
    enabled: !!projectId && enabled,
  });
}

export function useGetProjectMetadata(projectId: string) {
  return useQuery({
    queryKey: ProjectsQueryKeys.projectMetadata(projectId),
    queryFn: () => getProjectMetadata(projectId),
    enabled: !!projectId,
  });
}

export function useInferenceMetaFieldsQuery(enabled: boolean = true) {
  const projectId = useAppSelector(selectCurrentProjectId);

  return useQuery({
    queryKey: ProjectsQueryKeys.inferenceMetaFields(projectId),
    queryFn: () => getInferenceMetaFields(projectId),
    enabled: !!projectId && enabled,
  });
}
